import {
    Component,
    ElementRef,
    EventEmitter,
    HostBinding,
    Input,
    Output,
    OnDestroy,
    ChangeDetectionStrategy
} from "@angular/core";
import { lockedToAnimationFrames } from "@spscommerce/utils";

import { SpsTab } from "@spscommerce/ds-shared";

@Component({
    selector: "sps-list-toolbar",
    templateUrl: "./sps-list-toolbar.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpsListToolbarComponent implements OnDestroy {
    static readonly displayName = "sps-list-toolbar";
    static readonly props = {
        advancedSearch: "any",
        title: "string",
        tabs: "SpsTab[]",
        activeTab: "SpsTab",
        tabChange: { event: true, type: "SpsTab" },
    };

    @HostBinding("class.sps-list-toolbar") readonly _spsListToolbarClass = true;

    @Input() advancedSearch: any;

    @Input() title: string;

    @Input() tabs: SpsTab[];
    @Input() activeTab: SpsTab;
    @Output() tabChange = new EventEmitter<SpsTab>();

    @HostBinding("class.sps-list-toolbar--pinned")
    @HostBinding("class.z-stratum-bar")
    isPinned = false;

    @HostBinding("class.sps-list-toolbar--advanced-search-open")
    get advancedSearchIsOpen() {
        return this.advancedSearch ? this.advancedSearch.isOpen : false;
    }

    private _unpinScrollY: number;

    constructor(
        private _elementRef: ElementRef,
    ) {
        window.addEventListener("scroll", this.onScroll);
    }

    ngOnDestroy() {
        window.removeEventListener("scroll", this.onScroll);
    }

    @lockedToAnimationFrames
    onScroll() {
        const rect = this._elementRef.nativeElement.getBoundingClientRect();
        if (rect.height > 0 && rect.top <= 60) {
            if (typeof this._unpinScrollY === "number") {
                if (window.scrollY < this._unpinScrollY) {
                    this._unpinScrollY = null;
                    this.isPinned = false;
                    if (this.advancedSearch) {
                        this.advancedSearch.unpin();
                    }
                }
            } else {
                this._unpinScrollY = window.scrollY;
                this.isPinned = true;
                if (this.advancedSearch) {
                    this.advancedSearch.pin();
                }
            }
        }
    }
}
